import Container from "@components/Atomic/Container/Container";
import { StyledContainer } from "@components/Styled/Container";
import { clsx } from "clsx";
import React from "react";
import { withSizeGuide } from "./withSizeGuide";

const Wrapper = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(
      props.className,
      "flex flex-col items-start justify-between md:flex-row",
    )}
  />
);

const Content = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "pt-4 flex w-full flex-col items-center justify-center pb-giga",
    )}
  />
);

export const SizeGuide = withSizeGuide(
  ({ men, menTitle, sizeTitles, styles, women, womenTitle }) => {
    return (
      <Container styles={styles} data-component-type="section-size-guide">
        <Wrapper width="md">
          <Content>
            <table className="w-[380px]" style={{ borderSpacing: 0 }}>
              <caption className="mb-4 text-center font-display text-h2 leading-h3 md:text-[44px]">
                {womenTitle}
              </caption>
              <thead>
                <tr className="h-[48px] border-b text-hint font-medium uppercase tracking-heading">
                  <th scope="col" className="w-[68px] text-center">
                    US
                  </th>
                  <th scope="col" className="w-[68px] text-center">
                    BARED/EU
                  </th>
                  <th scope="col" className="w-[68px] text-center">
                    CM
                  </th>
                  <th scope="col" className="w-[68px] text-center">
                    IN
                  </th>
                </tr>
              </thead>
              <tbody>
                {women?.map((size) => (
                  <tr
                    key={size._key}
                    className="h-[48px] border-b border-tertiary tracking-heading"
                  >
                    {sizeTitles?.map((sizeTitle) => (
                      <td key={sizeTitle} className="w-[68px] text-center">
                        {size[sizeTitle]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </Content>

          <Content>
            <table className="w-[380px]" style={{ borderSpacing: 0 }}>
              <caption className="mb-4 text-center font-display text-h2 leading-h3 md:text-[44px]">
                {menTitle}
              </caption>
              <thead>
                <tr className="h-[48px] border-b text-hint font-medium uppercase tracking-heading">
                  <th scope="col" className="w-[68px] text-center">
                    US
                  </th>
                  <th scope="col" className="w-[68px] text-center">
                    BARED/EU
                  </th>
                  <th scope="col" className="w-[68px] text-center">
                    CM
                  </th>
                  <th scope="col" className="w-[68px] text-center">
                    IN
                  </th>
                </tr>
              </thead>
              <tbody>
                {men?.map((size) => (
                  <tr
                    key={size._key}
                    className="h-[48px] border-b border-tertiary tracking-heading"
                  >
                    {sizeTitles?.map((sizeTitle) => (
                      <td key={sizeTitle} className="w-[68px] text-center">
                        {size[sizeTitle]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </Content>
        </Wrapper>
      </Container>
    );
  },
);

export default SizeGuide;
